if (!window.laced) {
  window.laced = {}
}

window.laced.toggleVisibleModifier = function (target, className) {
  var visibleClass = className + '--visible'
  var targetVisible = target.classList.contains(visibleClass)

  var visibleElem = document.querySelector('.' + visibleClass)

  if (visibleElem) visibleElem.classList.remove(visibleClass)
  if (!targetVisible) {
    target.classList.add(visibleClass)
  }
}

window.laced.toggleElementsById = (ids) => {
  for (const id of ids) {
    document.getElementById(id)?.classList.toggle('hidden')
  }
}

window.laced.toggleElementById = (id) => {
  document.getElementById(id)?.classList.toggle('hidden')
}

window.laced.scrollToHashElem = () => {
  const hashElem = document.getElementById(
    window.location.hash.replace('#', '')
  )

  if (hashElem) hashElem.scrollIntoView(true)
}

document.addEventListener('DOMContentLoaded', window.laced.scrollToHashElem)

document.addEventListener('DOMContentLoaded', function () {
  var oneTimeLinks = document.querySelectorAll('a.one-time-link')

  for (var i = 0; i < oneTimeLinks.length; i++) {
    var link = oneTimeLinks[i]

    link.addEventListener('click', function (evt) {
      if (evt.target.classList.contains('clicked')) {
        evt.preventDefault()
      } else {
        evt.target.classList.add('clicked')
        evt.target.setAttribute('disabled', '')
      }
    })
  }
})
